package com.trevorwiebe.timesheet.mileage.data

import com.trevorwiebe.timesheet.core.data.ImageExtractionService
import kotlinx.serialization.Serializable

data class ExtractedReceiptData(
    val fuelVendor: String?,
    val city: String?,
    val state: String?,
    val gallons: Double?
)

@Serializable
private data class ReceiptResponse(
    val fuelVendor: String? = null,
    val city: String? = null,
    val state: String? = null,
    val gallons: Double? = null
)

class ReceiptExtractionService(private val extractor: ImageExtractionService) {
    private val prompt = """
        Extract the fuel vendor name, the city, the state (two-letter abbreviation),
        and the number of gallons from this fuel receipt image.
        Return only valid JSON with no extra text:
        {"fuelVendor": "", "city": "", "state": "", "gallons": 0.0}
        Use null for any field you cannot determine with confidence.
    """.trimIndent()

    suspend fun extract(imageBytes: ByteArray): ExtractedReceiptData {
        return try {
            val result = extractor.extract<ReceiptResponse>(imageBytes, prompt)
            ExtractedReceiptData(
                fuelVendor = result.fuelVendor,
                city       = result.city,
                state      = result.state,
                gallons    = result.gallons
            )
        } catch (e: Exception) {
            ExtractedReceiptData(null, null, null, null)
        }
    }
}
